export default __webpack_public_path__ + "static/media/excel.8cd54e17.svg";